const PDF_DATA_PREFIX = "data:application/pdf;base64,";

const isPdfDataUrl = (value) => value.indexOf("data:application/pdf") === 0;

const isRegularPdfUrl = (value) => {
  const lowerValue = String(value || "").toLowerCase();

  return (
    value.indexOf("blob:") === 0 ||
    value.indexOf("http://") === 0 ||
    value.indexOf("https://") === 0 ||
    value.indexOf("/") === 0 ||
    lowerValue.indexOf(".pdf") === lowerValue.length - 4 ||
    lowerValue.indexOf(".pdf?") > -1
  );
};

export const getPdfUrl = (pdf) => {
  const value = String(pdf || "").trim();

  if (!value) {
    return "";
  }

  if (isPdfDataUrl(value) || isRegularPdfUrl(value)) {
    return value;
  }

  return `${PDF_DATA_PREFIX}${value}`;
};

export const openPdfInNewTab = (pdf) => {
  const pdfSource = getPdfUrl(pdf);

  if (!pdfSource) {
    return;
  }

  if (isRegularPdfUrl(pdfSource)) {
    window.open(pdfSource, "_blank", "noopener,noreferrer");
    return;
  }

  try {
    const pureBase64 = pdfSource.replace(/^data:application\/pdf;base64,/, "");
    const byteCharacters = window.atob(pureBase64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let index = 0; index < byteCharacters.length; index += 1) {
      byteNumbers[index] = byteCharacters.charCodeAt(index);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const fileUrl = window.URL.createObjectURL(blob);

    window.open(fileUrl, "_blank", "noopener,noreferrer");
    window.setTimeout(() => window.URL.revokeObjectURL(fileUrl), 60000);
  } catch (error) {
    window.open(pdfSource, "_blank", "noopener,noreferrer");
  }
};
